<template>
  <div id="notfound">
    <NavBar></NavBar>
    <main
      role="main"
      property="mainContentOfPage"
      typeof="WebPageElement"
      class="container generic-container"
    >
      <div class="pt-6">
        <h1 class="title is-2 pb-4">
          {{ $t("not_found.title") }}
        </h1>
        <p class="is-size-4">
          {{ $t("not_found.text") }}
        </p>
        <ul class="list-bullet is-size-4">
          <li>
            <router-link :to="{ name: 'open-services' }">{{
              $t("not_found.home")
            }}</router-link>
          </li>
          <li>
            <a href="#" @click="contactModal()">
              {{ $t("not_found.contact") }}
            </a>
          </li>
        </ul>
      </div>
    </main>
    <BaseFooter></BaseFooter>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import ContactModal from "@/components/ContactModal.vue";
import BaseFooter from "@/components/Footer.vue";
export default {
  name: "error-page",
  components: {
    NavBar,
    BaseFooter
  },
  methods: {
    contactModal() {
      this.$buefy.modal.open({
        parent: this,
        component: ContactModal,
        hasModalCard: true
      });
    }
  },
  created() {
    document.title = this.$t("message.copy_error_title");
  },
  updated() {
    document.title = this.$t("message.copy_error_title");
  }
};
</script>
<style></style>
